import { IApplicationState } from '../../types/redux';

export const getUrlPath = (state: IApplicationState) => {
  return state.path || null;
};
